import React from 'react';
import headerLogo from '../assets/libby-header-logo.png';

const LINKS = [
  { href: '#foundation', label: 'About' },
  { href: '#explore', label: 'Explore' },
  { href: '#newsletter', label: 'Join the list' },
  { href: '#amazon', label: 'Buy now' },
];

export default function SiteNav({ solid }) {
  return (
    <header className={`site-nav${solid ? ' site-nav--solid' : ''}`}>
      <div className="site-nav__inner">
        <a href="#" className="site-nav__brand" aria-label="Libby the Lion & Friends">
          <img
            src={headerLogo}
            alt=""
            className="site-nav__logo"
            width={36}
            height={36}
            decoding="async"
            aria-hidden
          />
          <span className="site-nav__brand-text">
            <span className="site-nav__brand-line">Libby the Lion</span>
            <span className="site-nav__brand-sub">&amp; Friends</span>
          </span>
        </a>
        <nav className="site-nav__links" aria-label="Primary">
          {LINKS.map(({ href, label }) => (
            <a key={href} href={href} className="site-nav__link">
              {label}
            </a>
          ))}
        </nav>
      </div>
    </header>
  );
}
